import type { InstagramAccount } from "../types";

/**
 * Merge Instagram account rows from multiple page-scoped fetches (and/or ad-account
 * fetches), deduping by id and preferring non-empty display fields.
 */
export function mergeInstagramAccounts(
  rows: InstagramAccount[]
): InstagramAccount[] {
  const byId = new Map<string, InstagramAccount>();
  for (const acc of rows) {
    const id = acc?.id?.trim();
    if (!id) continue;
    const prev = byId.get(id);
    if (!prev) {
      byId.set(id, { ...acc, id });
      continue;
    }
    byId.set(id, {
      id,
      name: prev.name || acc.name || "",
      username: prev.username || acc.username || "",
      followers_count: Math.max(
        prev.followers_count ?? 0,
        acc.followers_count ?? 0
      ),
      profile_picture_url:
        prev.profile_picture_url || acc.profile_picture_url || "",
    });
  }
  return Array.from(byId.values());
}
